export const razorpayPaymentOption: {
    image: string;
    name: string;
    theme: {
        color: string;
    };
} = {
    image: "https://storage.googleapis.com/klinq-prod-public/klinq-brand-logo/klinq-brand-logo_1775482328529.jpg",
    name: "AUREUS FINVEST PRIVATE LIMITED",
    theme: {   color: "#23117e" },
};

export const razorpayMandateOption: {
    image: string;
    name: string;
    theme: {
        color: string;
    };
} = {
    image: "https://storage.googleapis.com/klinq-prod-public/klinq-brand-logo/klinq-brand-logo_1775482328529.jpg",
    name: "AUREUS FINVEST PRIVATE LIMITED",
    theme: {   color: "#23117e" },
};